export const DisabledBubble = () => (
  <div className="tl tl-relative tl-flex tl-h-16 tl-w-16 tl-cursor-not-allowed tl-rounded-full tl-shadow-lg"></div>
)
